// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__7AGDW","grid":"Footer_grid__Er3p4","list":"Footer_list__mJ128","item":"Footer_item__s4bQH","link":"Footer_link__NE5H5","text":"Footer_text__zmW1j"};